import { style } from '@vanilla-extract/css';
import { themeVars } from '@customerio/pluma-components/css/theme-tokens';

/**
 * Wrapper sets `position: relative` so the copy button can be
 * absolutely-positioned over the content's right edge.
 */
export const wrapper = style(
  {
    position: 'relative',
    display: 'inline-flex',
    maxWidth: '100%',
    minWidth: 0,
  },
  'copy-to-clipboard',
);

/**
 * Absolutely-positioned button container, hidden by default and
 * fading in on parent hover/focus-within. Mirrors the Ember
 * `copyToClipboardButtonContainer` style.
 */
export const buttonContainer = style(
  {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    transition: 'visibility 0s ease 0.2s, opacity 0.2s ease',
    visibility: 'hidden',
    opacity: 0,

    selectors: {
      [`${wrapper}:hover &, ${wrapper}:focus-within &`]: {
        visibility: 'visible',
        opacity: 1,
        transitionDelay: '0s',
      },
    },
  },
  'copy-to-clipboard-button-container',
);

/**
 * Copy button itself. The `boxShadow: -6px 0 6px 0 surface-base`
 * trick gives a soft gradient feathered into the underlying content
 * so the button doesn't look pasted on. Matches the Ember
 * `copyToClipboardButton` styling.
 */
export const button = style(
  {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    // Fill the container vertically so the gradient background covers
    // the full row height instead of just a centered icon-sized strip.
    alignSelf: 'stretch',
    height: '100%',
    padding: `0 ${themeVars.space['050']}`,
    backgroundColor: themeVars.color['surface-base'],
    boxShadow: `-6px 0 6px 0 ${themeVars.color['surface-base']}`,
    color: themeVars.color['text-base'],
    border: 'none',
    cursor: 'pointer',
    appearance: 'none',
    selectors: {
      '&:focus-visible': {
        outline: `${themeVars.border['width-025']} solid ${themeVars.color['border-focus']}`,
        outlineOffset: themeVars.space['025'],
      },
    },
  },
  'copy-to-clipboard-button',
);

/** A caller-supplied trigger is always visible (Ember's slotted buttons were). */
export const buttonContainerPersistent = style(
  {
    visibility: 'visible',
    opacity: 1,
    transition: 'none',
  },
  'copy-to-clipboard-button-container-persistent',
);
